import { Link } from "react-router-dom";
import { formatViews, getRelatedVideos, getCategoryBySlug } from "@/utils/format";

interface RelatedVideosProps {
  videoId: string;
  category: string;
  tags: string[];
}

export default function RelatedVideos({ videoId, category, tags }: RelatedVideosProps) {
  const related = getRelatedVideos(videoId, category, tags).slice(0, 5);
  const cat = getCategoryBySlug(category);

  return (
    <aside className="space-y-5">
      {cat && (
        <Link
          to={`/category/${cat.slug}`}
          className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
        >
          <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
            <i className={cat.icon} aria-hidden="true"></i>
          </span>
          <div className="flex-1">
            <p className="text-xs text-foreground-500">所属分类</p>
            <p className="font-heading font-semibold text-foreground-950">{cat.name}</p>
          </div>
          <i className="ri-arrow-right-line text-foreground-300" aria-hidden="true"></i>
        </Link>
      )}

      <div className="rounded-lg bg-background-50 border border-background-200 p-4">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-magic-line text-primary-500 text-lg" aria-hidden="true"></i>
          <h2 className="font-heading font-bold text-foreground-950">相关推荐</h2>
        </div>
        <ul className="space-y-3">
          {related.map((v) => (
            <li key={v.id}>
              <Link to={`/video/${v.id}`} className="flex gap-3 group">
                <div className="relative w-28 sm:w-32 aspect-video rounded overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={v.cover}
                    alt={v.title}
                    title={`${v.title} - 呱呱视频社区`}
                    className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform"
                  />
                  <span className="absolute bottom-1 right-1 px-1 rounded bg-black/70 text-white text-[10px]">
                    {v.duration}
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {v.title}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500 truncate">{v.author}</p>
                  <p className="mt-0.5 text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-play-circle-line" aria-hidden="true"></i>
                    {formatViews(v.views)}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}